import React, {useEffect, useState} from "react";
import {Avatar, Button, Card, Row, Spin, Tag} from "antd";
import {Link} from "react-router-dom";
import dayjs from "dayjs";
import relativeTime from "dayjs/plugin/relativeTime";
import Api from "../../api";

dayjs.extend(relativeTime);

const LatestComments = () => {
    const [comments, setComments] = useState([]);
    const [loading, setLoading] = useState(false);

    useEffect(() => {
        setLoading(true);
        Api.get("/admin/comments", {
            per_page: 5,
            page: 1,
        })
            .then((res) => {
                setComments(res.data.data);
            })
            .finally(() => setLoading(false));
    }, []);

    return (
        <Card
            className="dashboard-feed-card"
            title={
                <Row type="flex" align="middle" justify="space-between">
                    <span>Latest Comments</span>
                    <Link to="/comments">
                        <Button type="link">View all</Button>
                    </Link>
                </Row>
            }
            bordered={false}
        >
            {loading ? (
                <Spin/>
            ) : (
                <div className="feed-list">
                    {comments.map((item) => (
                        <div key={item.id} className="feed-item">
                            <div className="feed-item__comment">
                                <Avatar size="small" src={item.user?.avatar}>
                                    {(item.user?.name_f || "?").charAt(0)}
                                </Avatar>

                                <div className="feed-item__main">
                                    <div className="feed-item__row">
                                        <Link className="feed-item__title" to={`/user/${item.user?.user_id || ""}`}>
                                            {item.user?.name_f || "Unknown"}
                                        </Link>
                                        <Tag>{dayjs(item.created_at).fromNow()}</Tag>
                                    </div>

                                    <p className="feed-item__text" title={item.body}>
                                        {item.body}
                                    </p>

                                    {item.commentable_type && (
                                        <span className="feed-item__type">{item.commentable_type}</span>
                                    )}
                                </div>
                            </div>
                        </div>
                    ))}
                </div>
            )}
        </Card>
    );
};

export default LatestComments;
